import React from 'react'

import Grid from '@material-ui/core/Grid'

import LabeledValue from 'components/LabeledValue'

type LabeledValueProps = React.ComponentProps<typeof LabeledValue>

interface Props {
  label: LabeledValueProps['label']
  value: LabeledValueProps['value']
}

const Label: React.SFC<Props> = (props) => (
  <Grid xs={4} item>
    <LabeledValue {...props} valueVariant="body2" />
  </Grid>
)

export default Label
